/* "More from [vendor/collection]": fetches the shop's own search or
   collection page and lifts its product grid out client side, since
   Shopify's recommendations endpoint (used by product-recommendations.js)
   has no vendor or collection filter to hand this data over directly.

   Cards arrive already built as .pb-card markup inside #PbProductGrid —
   this only has to re-home them into carousel slides, not rebuild them. */
(function () {
  var roots = document.querySelectorAll('[data-more-from]');
  if (!roots.length) return;

  function load(root) {
    var url = root.getAttribute('data-url');
    var currentId = root.getAttribute('data-current-id');
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 10;
    var track = root.querySelector('[data-more-from-track]');
    var carousel = root.querySelector('[data-carousel]');
    if (!url || !track || !carousel) return;

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Unavailable');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelectorAll('#PbProductGrid .pb-card');

        var added = 0;
        cards.forEach(function (card) {
          if (added >= limit) return;
          if (card.getAttribute('data-product-id') === currentId) return;

          var slide = document.createElement('li');
          slide.className = 'pb-carousel__slide';
          slide.appendChild(card.cloneNode(true));
          track.appendChild(slide);
          added += 1;
        });

        if (!added) {
          root.remove();
          return;
        }

        carousel.hidden = false;
        carousel.dispatchEvent(new CustomEvent('pb:carousel-init', { bubbles: true }));
      })
      .catch(function () {
        root.remove();
      });
  }

  if (!('IntersectionObserver' in window)) {
    roots.forEach(load);
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        load(entry.target);
      });
    },
    { rootMargin: '400px 0px' }
  );

  roots.forEach(function (root) {
    observer.observe(root);
  });
})();
